import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Configuration {
  id: string;
  key: string;
  name?: string | null;
  display_label?: string;
  type: string;
  value: any;
  created_at?: string;
  updated_at?: string;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class ConfigurationsService {
  private baseUrl = '/api/configurations';

  constructor(private http: HttpClient) {}

  list(type?: string): Observable<{ configurations: Configuration[] }> {
    let params = new HttpParams();
    if (type) {
      params = params.set('type', type);
    }
    return this.http.get<{ configurations: Configuration[] }>(`${this.baseUrl}/`, { params });
  }

  get(config_id: string): Observable<{ configuration: Configuration }> {
    return this.http.get<{ configuration: Configuration }>(`${this.baseUrl}/${config_id}`);
  }

  create(type: string, data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/${type}`, data);
  }

  update(type: string, config_id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/${type}/${config_id}`, data);
  }

  delete(config_id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/${config_id}`);
  }

  listAllowedForMe(): Observable<{ configurations: Configuration[] }> {
    return this.http.get<{ configurations: Configuration[] }>(`${this.baseUrl}/me`);
  }
}